/* eslint-disable */
import React from "react";
import { useSpring, animated } from "react-spring";
import EpisodeList from "./EpisodeList";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PersonIcon from "@material-ui/icons/Person";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TextsmsIcon from "@material-ui/icons/Textsms";
import styles from "./ProgramDetail.module.css";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import {
  Button,
  CardActions,
  createStyles,
  Divider,
  makeStyles,
  Theme,
} from "@material-ui/core";

import { Video, RelatedVideo } from "../../../stores/program/model/Program";

import { useNavigate } from "react-router-dom";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../components/elements/PuiTypography";
import useResponsive from "../../../common/useResponsive";
import { useDispatch } from "react-redux";
import { resetfilter } from "../../../common/video/VideoFilterActions";

interface FadeProps {
  children?: React.ReactElement;
  in: boolean;
  onEnter?: () => {};
  onExited?: () => {};
  title: string;
  description?: string;
  episodelist?: Video[];
  selected?: Video;
  related?: RelatedVideo[];
}

const ProgramDetail = React.forwardRef<HTMLDivElement, FadeProps>(
  
  function ProgramDetail(props, ref) {
    const [selected, setSelected] = React.useState<Video | undefined>(
      props.selected
    );

    const history = useNavigate();
    const { isMobile } = useResponsive();
    const { in: open, onEnter, onExited } = props;
    const style = useSpring({
      from: { opacity: 0 },
      to: { opacity: open ? 1 : 0 },
      onStart: () => {
        if (open && onEnter) {
          onEnter();
        }
      },
      onRest: () => {
        if (!open && onExited) {
          onExited();
        }
      },
    });

    // プログラム詳細のスタイル
    // const useStyles = makeStyles((_theme: Theme) =>
    //     createStyles({
    //         imgFullHeight: {
    //             left:0,
    //             transform:"none"
    //        },
    //         imgFullWidth: {
    //             top:0,
    //             transform:"none"
    //        },
    //         tag: {
    //             marginRight: "10px",
    //             marginBottom: "5px",
    //             borderRadius: "2em",
    //             backgroundColor: "var(--red)",
    //             cursor: "default",
    //             pointerEvents: "none",
    //             textTransform: "none",
    //             "&:hover": {
    //                 backgroundColor: "var(--red)",
    //                 boxShadow: "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)"
    //            }
    //        },
    //         iconText: {
    //             color:"#ffffff",
    //             marginRight: "8px"
    //        },
    //         relatedVideoTitle: {
    //             position: "relative",
    //             marginTop: "-16px",
    //             marginLeft: "-24px",
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //             whiteSpace: "nowrap"
    //        },
    //         divider: {
    //             margin: "10px -16px 8px -16px"
    //        },
    //         relatedVideoIconRow: {
    //             display: "flex",
    //             justifyContent: "space-evenly",
    //             marginLeft: "-24px",
    //             marginRight: "-16px",
    //             marginTop: "-8px"
    //        }
    //    })
    // );

    // const classes = useStyles();

    // タグリスト表示
    const makeTags = (episodeList: Video[]) => {
      const dispatch = useDispatch();
  
      const handleClick = (tagName: string) => {
        console.log("tagName:", tagName);
        
        const videoFilter = {
          id: [],
          professional: [],
          program: [],
          project: [],
          tag: [tagName],
        };
        dispatch(resetfilter(videoFilter));
        setTimeout(() => history("/videos"), 100);
      };
      let tags: string[] = [];
      for (let index = 0; index < episodeList.length; index++) {
        tags = tags.concat(episodeList[index].tags);
      }
      tags = tags.filter((value, index) => tags.indexOf(value) === index);
      const tagList: any[] = [];
      for (let i = 0; i < tags.length; i++) {
        tagList.push(
          <Button
            key={i}
            size="small"
            color="secondary"
            variant="contained"
            onClick={() => handleClick(tags[i])}
            // className={classes.tag}
          >
            <PuiTypography size={14} bold={true} color="white">
              {tags[i]}
            </PuiTypography>
          </Button>
        );
      }
      return tagList;
    };

    // 文字列結合
    const formatStr = (episodeList: Video[]) => {
      let presenterList: string[] = [];
      let presenters = "";
      episodeList.map((item) => presenterList.push(item.presenter));
      presenterList = presenterList.filter(
        (value, index) =>
          presenterList.indexOf(value) === index && value !== "UNKNOWN"
      );
      presenterList.map((item) => (presenters += item + "、"));
      presenters = presenters.substring(0, presenters.length - 1);
      return presenters;
    };

    // フォーカスビデオの変更
    const onFocus = (focus: Video) => {
      setSelected(focus);
    };
    const dispatch = useDispatch();

    const handleClick = (tagName: string) => {
      console.log("tagName:", tagName);
      
      const videoFilter = {
        id: [],
        professional: [],
        program: [],
        project: [],
        tag: [tagName],
      };
      dispatch(resetfilter(videoFilter));
      setTimeout(() => history("/videos"), 100);
    };

    return (
      <animated.div ref={ref} style={style}>
        {/* {children} */}
        <div className={styles.modalBody}>
          <div className={styles.detail}>
            <div className={styles.detailTopArea}>
              <div
                className={styles.programTitle}
                data-tip={props.title}
                data-for="programTitle"
              >
                <PuiTypography size={isMobile ?  16 : 20} bold={true} rows={1}>
                  {props.title}
                </PuiTypography>
              </div>
              <PuiTooltip id={"programTitle"} />
              <div
                className={styles.programDescription}
                data-tip={props.description}
                data-for="programDescription"
              >
                <PuiTypography size={isMobile ? 16 : 20}>
                  {String(props.description)}
                </PuiTypography>
              </div>
              <PuiTooltip id={"programDescription"} />
            </div>
            <div className={styles.detailTopArea}>
              <div className={styles.programRightTitle}>
                <PuiTypography size={isMobile ?  14 : 16} bold={true} color="gray-61" rows={1}>
                  出演Presenter
                </PuiTypography>
              </div>
              <div className={styles.programProfessional}>
                <PuiTypography size={isMobile ?  14 : 16} bold={true}  rows={1}>
                  <span >{String(props.episodelist && formatStr(props.episodelist))}</span>
                </PuiTypography>
              </div>
              <div className={styles.programRightTitle}>
                <PuiTypography size={isMobile ?  14 : 16} bold={true} color="gray-61">
                  Tags
                </PuiTypography>
              </div>
              <div className={styles.tags}>
                {props.episodelist && makeTags(props.episodelist)}
              </div>
            </div>
          </div>
          <div className={styles.detail}>
            {selected && (
              <div className={styles.selected}>
                <img
                  src={selected.imageUrl}
                  className={styles.selectedImg}
                  alt={selected.title}
                />
                <div className={styles.titleBar}>
                  <div className={styles.professional}>
                    <PersonIcon
                      aria-hidden="true"
                      style={{ width: isMobile?20:25, height: isMobile?20:25, color: "#ffffff" }}
                    />
                    <PuiTypography
                      size={isMobile ? 16 : 20}
                      bold={isMobile ?  false : true}
                      color="white"
                      rows={1}
                    >{`Presenter：${selected.presenter}`}</PuiTypography>
                  </div>
                  <div
                    className={styles.title}
                    data-tip={selected.title}
                    data-for="detailTitle"
                  >
                    <PuiTypography size={isMobile ? 16 : 24} bold={true} color="white" rows={1}>
                      {selected.title}
                    </PuiTypography>
                  </div>
                  <div
                    className={styles.subtitle}
                    data-tip={selected.description}
                    data-for="detailSubtitle"
                  >
                    <PuiTypography size={isMobile ? 12 : 16} color="white">
                      {selected.description}
                    </PuiTypography>
                  </div>
                </div>
                <PuiTooltip id={"detailTitle"} />
                <PuiTooltip id={"detailSubtitle"} />
                <div className={styles.centerIcon}>
                  <PlayCircleFilledIcon
                    style={{ width: 100, height: 100, cursor: "pointer" }}
                    onClick={() => history("/video/" + selected.hash)}
                  />
                </div>
                <div className={styles.iconBox}>
                  <div className={styles.viewIcon}>
                    {/* <VisibilityIcon aria-hidden="true" className={classes.iconText}/> */}
                    <PuiTypography
                      size={isMobile ? 12 : 14}
                      bold={true}
                      color="white"
                      rows={1}
                    >{`views：${selected.viewCount}`}</PuiTypography>
                  </div>
                  <div className={styles.thumbUpIcon}>
                    {/* <ThumbUpIcon aria-hidden="true" className={classes.iconText}/> */}
                    <PuiTypography
                      size={isMobile ? 12 : 14}
                      bold={true}
                      color="white"
                      rows={1}
                    >{`reactions：${selected.reactionsCount}`}</PuiTypography>
                  </div>
                  <div className={styles.commentIcon}>
                    {/* <TextsmsIcon aria-hidden="true" className={classes.iconText}/> */}
                    <PuiTypography
                      size={isMobile ? 12 : 14}
                      bold={true}
                      color="white"
                      rows={1}
                    >{`comments：${selected.commentsCount}`}</PuiTypography>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.episode}>
              {props.episodelist && props.selected && (
                <EpisodeList
                  itemList={props.episodelist}
                  title="エピソード"
                  imageShape="square"
                  selected={selected}
                  onCallback={onFocus}
                />
              )}
            </div>
          </div>
          {props.related && props.related.length > 0 && (
            <div>
              <div className={styles.titleText}>
                <PuiTypography size={isMobile ? 16 : 20} bold={true} rows={1}>
                  こちらもおすすめ
                </PuiTypography>
              </div>
              <div className={styles.spinoff}>
                {props.related.map((item) => (
                  <Card
                    key={item.id}
                    className={styles.itemCard}
                    onClick={() => history("/video/" + item.hash)}
                  >
                    <CardActionArea>
                      <CardMedia
                        className={styles.cardMedia}
                        image={item.imageUrl}
                      />
                      <CardContent>
                        <CardActions
                          //   className={{}}
                          data-tip={item.title}
                          data-for="relatedVideoTitle"
                        >
                          <PuiTypography size={isMobile ? 16 : 20} bold={true} rows={1}>
                            {item.title}
                          </PuiTypography>
                          <PuiTooltip id={"relatedVideoTitle"} />
                        </CardActions>
                        <CardActions>
                          <PersonIcon
                            aria-hidden="true"
                            style={{
                              width: 20,
                              height: 20,
                              color: "var(--gray-61)",
                              marginLeft: "-26px",
                              marginTop: "-17px",
                            }}
                          />
                          <div className={styles.iconTitle}>
                            <PuiTypography color="gray-61" rows={1}>
                              {item.presenter}
                            </PuiTypography>
                          </div>
                        </CardActions>
                        <Divider
                          variant="fullWidth"
                          //   className={classes.divider}
                        />
                        <CardActions
                        // className={classes.relatedVideoIconRow}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <VisibilityIcon
                              aria-hidden="true"
                              style={{
                                color: "var(--gray-61)",
                                marginRight: "8px",
                              }}
                            />
                            <PuiTypography bold={true} color="gray-61" rows={1}>
                              {String(item.viewCount)}
                            </PuiTypography>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ThumbUpIcon
                              aria-hidden="true"
                              style={{
                                color: "var(--gray-61)",
                                marginRight: "8px",
                              }}
                            />
                            <PuiTypography bold={true} color="gray-61" rows={1}>
                              {String(item.reactionsCount)}
                            </PuiTypography>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <TextsmsIcon
                              aria-hidden="true"
                              style={{
                                color: "var(--gray-61)",
                                marginRight: "8px",
                              }}
                            />
                            <PuiTypography bold={true} color="gray-61" rows={1}>
                              {String(item.commentsCount)}
                            </PuiTypography>
                          </div>
                        </CardActions>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      </animated.div>
    );
  }
);
export default ProgramDetail;
